"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_use_1 = require("react-use");
const ModalContent = ({ modal, onClose, onLayout }) => {
    const contentSize = (0, react_1.useRef)();
    const [Content, { width, height }] = (0, react_use_1.useSize)(() => {
        return ((0, jsx_runtime_1.jsx)("div", { style: {
                height: '100%',
                display: 'block',
                overflow: 'auto',
            }, children: (0, react_1.cloneElement)(modal.component, {
                ...modal.options,
                onClose,
                style: { cursor: 'default' },
            }) }));
    });
    (0, react_1.useEffect)(() => {
        if (Number.isFinite(height) &&
            Number.isFinite(width) &&
            !contentSize.current) {
            contentSize.current = { width, height };
            onLayout({ modal, layout: { width, height } });
        }
    }, [width, height, contentSize, onLayout, modal]);
    return Content;
};
exports.default = ModalContent;
